<template>
  <tab-layout :full-width="true">
    <div slot="tabContent" class="bg-white rounded mb-4 p-3">
      <page-heading>Send bulk email/text</page-heading>

      <form @submit.prevent="onSubmit">
        <div class="row mb-3">
          <div class="col-12 col-md-6 mb-3 mb-md-0">
            <f-search-select
              id="bulk-send-type"
              label="Send Type"
              :options="sendTypes"
              option-label="label"
              v-model="form.sendType"
            />
          </div>
          <div class="col-12 col-md-6">
            <f-search-select
              id="bulk-send-to"
              label="Send To"
              :options="recipients"
              option-label="label"
              v-model="form.sendTo"
              @input="onSendToChange"
            />
          </div>
        </div>

        <div v-if="showCommitteeSelect" class="mb-3">
          <label class="font-weight-bold">Committees</label>
          <app-multiselect
            v-model="form.committees"
            :options="committeeOptions"
            :multiple="true"
            :allow-empty="true"
            :loading="searchLoading"
            :internal-search="false"
            placeholder="Search committees..."
            label="name"
            track-by="id"
            @search-change="onCommitteeSearch"
          />
        </div>

        <div class="mb-3">
          <f-textarea
            id="bulk-text"
            label="Text"
            v-model="form.text"
            :rows="6"
            required
            placeholder="Enter your message..."
          />
        </div>

        <app-button variant="primary" :block="false" type="submit" :loading="sending">Send</app-button>
      </form>
    </div>
  </tab-layout>
</template>

<script>
import { defineComponent, reactive, computed, onMounted } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import PageHeading from '@/components/PageHeading'
import AppButton from '@/components/AppButton'
import AppMultiselect from '@/components/AppMultiselect'
import FSearchSelect from '@/components/FormFields/FSearchSelect'
import FTextarea from '@/components/FormFields/FTextarea'
import useCommitteesBulkMail from '@/composables/committees/useCommitteesBulkMail'

export default defineComponent({
  name: 'CommitteesBulkMail',
  components: { TabLayout, PageHeading, AppButton, AppMultiselect, FSearchSelect, FTextarea },
  setup() {
    const bulkMail = useCommitteesBulkMail()

    const form = reactive({
      sendType: null,
      sendTo: null,
      committees: [],
      text: ''
    })

    const showCommitteeSelect = computed(() => form.sendTo === 'selected')

    const committeeOptions = computed(() => {
      const selectedIds = new Set(form.committees.map(c => c.id))
      const merged = [...form.committees]
      bulkMail.searchResults.value.forEach((r) => {
        if (!selectedIds.has(r.id)) merged.push(r)
      })
      return merged
    })

    function onSendToChange(val) {
      if (val === 'selected') {
        bulkMail.search({ q: '' })
      }
    }

    function onCommitteeSearch(query) {
      bulkMail.search({ q: query })
    }

    async function onSubmit() {
      if (form.sendType == null || form.sendTo == null || !form.text) return
      const data = {
        send_type: form.sendType,
        send_to: form.sendTo,
        bulk_text: form.text
      }
      if (form.sendTo === 'selected') {
        data.committee_ids = form.committees.map(c => c.id)
      }
      const result = await bulkMail.send(data)
      if (result != null) {
        form.sendType = null
        form.sendTo = null
        form.committees = []
        form.text = ''
      }
    }

    onMounted(() => {
      bulkMail.fetchOptions()
    })

    return {
      form,
      sendTypes: bulkMail.sendTypes,
      recipients: bulkMail.recipients,
      committeeOptions,
      searchLoading: bulkMail.loading,
      sending: bulkMail.sending,
      showCommitteeSelect,
      onSendToChange,
      onCommitteeSearch,
      onSubmit
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/Committees/BulkMail/CommitteesBulkMail.vue